export const getLSValue = (store, value = ``) => {
  if (localStorage.getItem(`${store}`)) {
    if (JSON.parse(localStorage.getItem(`${store}`))[value]) {
      return JSON.parse(localStorage.getItem(`${store}`))[value];
    }
  } else {
    return undefined;
  }
};
